export default {
  'billingSubscriptions.columns.companyName': 'Company / Name',
  'billingSubscriptions.columns.companyIdentity': 'Company / Tax ID',
  'billingSubscriptions.fields.billingLegalName': 'Billing legal name',
  'billingSubscriptions.changePlan.action': 'Change plan',
  'billingSubscriptions.changePlan.title': 'Change plan',
  'billingSubscriptions.changePlan.currentPlan': 'Current plan',
  'billingSubscriptions.changePlan.newPlan': 'New plan',
  'billingSubscriptions.changePlan.confirmTitle': 'Change company plan?',
  'billingSubscriptions.changePlan.immediate':
    'The new plan configuration and limits will apply immediately.',
  'billingSubscriptions.changePlan.success': 'Plan changed successfully.',
  'billingSubscriptions.changePlan.includedCredit': 'Monthly included AI credit',
  'billingSubscriptions.suspension.suspend': 'Suspend',
  'billingSubscriptions.suspension.reactivate': 'Reactivate',
  'billingSubscriptions.suspension.suspendTitle': 'Suspend {company} subscription?',
  'billingSubscriptions.suspension.reactivateTitle': 'Reactivate {company} subscription?',
  'billingSubscriptions.suspension.suspendMessage':
    'Review the impact before confirming the suspension.',
  'billingSubscriptions.suspension.reactivateMessage':
    'This restores this company. The backend recalculates its billing status, which may remain pending payment, past due, or active. A suspended commercial actor returns to active; this is not an approval.',
  'billingSubscriptions.suspension.helpCompanyOnly':
    'This action suspends only this company and blocks its access and commercial operations.',
  'billingSubscriptions.suspension.helpNoCascade':
    'Related companies will not be suspended. It currently has {actors} commercial actors and {customers} associated customers.',
  'billingSubscriptions.suspension.helpPayment':
    'Payments initiated before the suspension may complete, but they will not reactivate the subscription.',
  'billingSubscriptions.suspension.reason': 'Suspension reason',
  'billingSubscriptions.suspension.reasonPlaceholder':
    'Explain why this subscription is suspended.',
  'billingSubscriptions.suspension.reasonCounter': '{current}/{maximum} characters',
  'billingSubscriptions.suspension.suspendedAt': 'Suspended at',
  'billingSubscriptions.suspension.suspendedBy': 'Suspended by',
  'billingSubscriptions.suspension.lastReactivatedAt': 'Last reactivated at',
  'billingSubscriptions.suspension.lastReactivatedBy': 'Last reactivated by',
  'billingSubscriptions.suspension.commercialActorKind': 'Commercial actor kind',
  'billingSubscriptions.suspension.commercialActorStatus': 'Commercial actor status',
  'billingSubscriptions.suspension.descendantActors': 'Descendant actors',
  'billingSubscriptions.suspension.descendantCustomers': 'Descendant customers',
};
